import type { Variable_Speed_Drives } from "gql/api";
import type { EquipmentTableColumn } from "@/composables/equipment/equipmentTypes";

export const vsdTableColumns: EquipmentTableColumn<Variable_Speed_Drives>[] = [
  {
    editable: true,
    field: "include_koc_timestamp",
    header: "Include KOC",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_koc_timestamp",
    header: "KOC Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "include_ecopetrol_timestamp",
    header: "Include Ecopetrol",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "only_ecopetrol_timestamp",
    header: "Ecopetrol Only",
    sortable: true,
    isCheckbox: true,
    adminOnly: true
  },
  {
    editable: true,
    field: "manufacturer",
    header: "Manufacturer",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "part_number",
    header: "Part Number",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "enclosure",
    header: "Enclosure",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "vsd_type",
    header: "VSD Type",
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "kva",
    header: "kVa",
    isNumber: true,
    sortable: true,
    searchable: true
  },
  {
    editable: true,
    field: "max_amps",
    header: "Max Amps",
    isNumber: true,
    sortable: true,
    searchable: true
  }
];
